import React from "react";

function UserAgreement() {
  return (
    <div className="bg-white container">
      <h1>Border City Software User Agreement</h1>

      <p>
        <strong>Last Updated</strong> 09 December 2025
      </p>

      <h2>1 Acceptance of Terms</h2>
      <p>
        This user agreement sets out the terms for using services provided by Border City Software. By creating an
        account or using any Border City Software service you agree to follow all terms in this agreement.
      </p>

      <h2>2 Use of the Service</h2>
      <p>You may use our services only for lawful purposes. You agree that you will not</p>
      <ul>
        <li>Interfere with or disrupt operation of the service</li>
        <li>Attempt to access systems or data that you are not permitted to access</li>
        <li>Use the service for fraudulent abusive or harmful activity</li>
      </ul>

      <h2>3 User Accounts</h2>
      <p>
        You are responsible for keeping your account details secure. You must notify us as soon as possible if you
        believe your account has been accessed without permission.
      </p>

      <h2>4 Ownership and Intellectual Property</h2>
      <p>
        All content code branding and materials provided by Border City Software remain the property of Border City
        Software or its licensors. You receive a limited right to use the service as intended. You may not copy
        resell or distribute our materials without written approval from us.
      </p>

      <h2>5 Service Availability</h2>
      <p>
        We work to provide stable service but we do not promise that the service will always be available or free
        from error. Border City Software may update change or suspend any part of the service at any time.
      </p>

      <h2>6 Limitation of Liability</h2>
      <p>
        As far as the law allows Border City Software is not responsible for loss of data service interruption or
        any indirect or consequential damages that result from use of the service. Your use of the service is at
        your own risk.
      </p>

      <h2>7 Termination</h2>
      <p>
        We may suspend or terminate your access to the service if you violate this agreement misuse the service
        or if we are required to do so by law.
      </p>

      <h2>8 Changes to This Agreement</h2>
      <p>
        We may update this agreement from time to time. When we make material changes we will take reasonable
        steps to let you know. Your continued use of the service after changes are made means that you accept
        the updated terms.
      </p>

      <h2>9 Contact Us</h2>
      <p>
        For questions about this agreement contact
        <br />
        <strong>Border City Software</strong>
        <br />
        Info@bordercitysoftware.com
      </p>
    </div>
  );
}

export default UserAgreement;
